import { render, staticRenderFns } from "./LTextPrompt.vue?vue&type=template&id=78180996"
import script from "./LTextPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./LTextPrompt.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports